module.exports = __webpack_public_path__ + "static/bn-1d4e60918c474f844110c46d560233b8.svg";